export default "__VITE_ASSET__0cd3c39c__"